import React, { useEffect } from "react";
import { FaTrash } from "react-icons/fa6";
import { IoPencilSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
function Events({
  setIsEditEventModalOpen,
  getEvents,
  events,
  setEditEvent,
  setIsConfirmationModalOpen,
  setId,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    getEvents();
  }, []);

  const copyLink = (link) => {
    navigator.clipboard.writeText(link);
    toast.success("Copied Whatsapp Link");
    return;
  };

  return (
    <div className="w-full overflow-x-scroll">
      {/* table */}
      <div className="border-t border-gray-70 lg:w-full w-[180%]">
        <div className="w-full flex border-b border-gray-70 p-2 font-semibold">
          <div className="w-[10%] flex justify-center">ID</div>
          <div className="w-[40%] flex justify-center">Name of Event</div>
          <div className="w-[30%] flex justify-center items-center">
            Whatsapp Link
          </div>
          <div className="w-[10%] flex justify-center"></div>
          <div className="w-[10%] flex justify-center"></div>
        </div>
        {events.length < 1 ? (
          <p className="mt-2 capitalize">No event available</p>
        ) : (
          events.map((event) => (
            <div
              className="w-full flex border-b border-gray-70 p-2"
              key={event.id}
            >
              <div className="w-[10%] flex justify-center items-center">
                <p className="hover:cursor-pointer">{event.id}</p>
              </div>
              {/* name of event and image */}
              <div className="w-[40%] flex justify-center items-center space-x-3 ">
                <div
                  onClick={() => {
                    navigate(`/attendees/${event.name}`);
                  }}
                  className="w-16 h-10 hover:cursor-pointer"
                >
                  <img
                    className="w-full h-full object-cover"
                    src={event.poster}
                    alt=""
                  />
                </div>
                <div
                  onClick={() => {
                    navigate(`/attendees/${event.name}`);
                  }}
                  className="w-96  capitalize"
                >
                  <p className="hover:cursor-pointer hover:text-purple text-center">
                    {event.name}
                  </p>
                </div>
              </div>
              {/* whatsapp link */}
              <div className="w-[30%] flex justify-center items-center text-center">
                <p
                  onClick={() => {
                    copyLink(event.whatsapp_url);
                  }}
                  className="hover:text-purple hover:cursor-pointer"
                >
                  {event.whatsapp_url.substring(0, 13)}
                </p>
              </div>
              <div className="w-[10%] flex justify-center items-center">
                <FaTrash
                  onClick={() => {
                    setIsConfirmationModalOpen(true);
                    setId(event.id);
                  }}
                  className="text-red-50 hover:cursor-pointer"
                />
              </div>
              <div className="w-[10%] flex justify-center items-center">
                <IoPencilSharp
                  onClick={() => {
                    setIsEditEventModalOpen(true);
                    setEditEvent(event);
                  }}
                  className="hover:cursor-pointer"
                />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Events;
